(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["as-approved-guide-behaviour"] && !Shopify.designMode) return;
  try {
    (() => {
  const rail = document.querySelector('#as-live-guides .guide-rail');
  if (!rail) return;
  const links = [...rail.querySelectorAll('nav a[data-section-label]')];
  const targets = links.map(link => ({link, target: document.getElementById(link.hash.slice(1))})).filter(x => x.target);
  let scheduled = false;
  let previousActive = null;
  const setActive = (link, forceOpen = false) => {
    if (link && (link !== previousActive || forceOpen)) {
      const group = link.closest('.chapter');
      const previousGroup = previousActive && previousActive.closest('.chapter');
      if (previousGroup && previousGroup !== group) {
        const previousButton = previousGroup.querySelector('.chapter-toggle');
        if (previousButton) {
          document.getElementById(previousButton.getAttribute('aria-controls')).hidden = true;
          previousButton.setAttribute('aria-expanded', 'false');
          previousButton.setAttribute('aria-label', 'Show subsections: ' + previousButton.parentElement.querySelector('a').dataset.sectionLabel);
        }
      }
      const button = group && group.querySelector('.chapter-toggle');
      if (button) {
        document.getElementById(button.getAttribute('aria-controls')).hidden = false;
        button.setAttribute('aria-expanded', 'true');
        button.setAttribute('aria-label', 'Hide subsections: ' + button.parentElement.querySelector('a').dataset.sectionLabel);
      }
    }
    previousActive = link;
    links.forEach(a => {
      const active = a === link;
      if (active) a.setAttribute('aria-current', 'location');
      else a.removeAttribute('aria-current');
    });
    rail.querySelectorAll('.chapter').forEach(group => group.classList.toggle('current-chapter', !!link && group.contains(link)));
    const position = rail.querySelector('.reading-position strong');
    if (position) position.textContent = link ? link.dataset.sectionLabel : 'Introduction';
    fitRail();
  };
  const update = () => {
    scheduled = false;
    let current;
    for (const item of targets) { if (item.target.getBoundingClientRect().top <= 150) current = item; }
    setActive(current ? current.link : null);
  };
  rail.classList.add('navigation-ready');
  const fitRail = () => {
    rail.classList.remove('rail-tall');
    const active = rail.querySelector('a[aria-current="location"]');
    const height = rail.offsetHeight;
    const viewport = window.innerHeight;
    let top = 24;
    // A long menu stays sticky too. Move only as far as necessary to keep
    // the current entry visible instead of adding an inner scrollbar.
    if (active && height > viewport - 48) {
      const offset = active.getBoundingClientRect().bottom - rail.getBoundingClientRect().top;
      top = Math.min(24, Math.max(viewport - height - 24, viewport - offset - 80));
    }
    rail.style.setProperty('--rail-sticky-top', top + 'px');
  };
  rail.querySelectorAll('.chapter-toggle').forEach(button => {
    button.addEventListener('click', () => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const expand = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expand));
      button.setAttribute('aria-label', (expand ? 'Hide' : 'Show') + ' subsections: ' + button.parentElement.querySelector('a').dataset.sectionLabel);
      panel.hidden = !expand;
      fitRail();
    });
  });
  const revealDestination = () => {
    const link = links.find(a => a.hash === window.location.hash);
    const panel = link && link.closest('.chapter-sections');
    if (panel) {
      panel.hidden = false;
      const button = rail.querySelector('[aria-controls="' + panel.id + '"]');
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', 'Hide subsections: ' + button.parentElement.querySelector('a').dataset.sectionLabel);
    }
    fitRail();
  };
  links.forEach(link => link.addEventListener('click', () => setActive(link, true)));
  window.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }, {passive: true});
  window.addEventListener('resize', () => {fitRail();update();});
  window.addEventListener('hashchange', revealDestination);
  rail.querySelector('.contents').addEventListener('toggle',fitRail);
  revealDestination();
  update();
})();

(() => {
  const input = document.querySelector('#as-live-guides #search'); if (!input) return;
  const buttons = [...document.getElementById('as-live-guides').querySelectorAll('[data-filter]')];
  let filter = 'all';
  const update = () => {
    let count = 0;
    const selected = buttons.find(b => b.dataset.filter === filter);
    const label = selected.textContent.trim();
    buttons.forEach(b => {const active = b === selected;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active));});
    document.getElementById('as-live-guides').querySelectorAll('.guide-card').forEach(card => {
      const category = card.dataset.category;
      const matches = filter === 'all' || category === filter || filter === 'other' && !['Buying advice','Process guide','Troubleshooting'].includes(category);
      card.hidden = !(matches && card.dataset.search.includes(input.value.trim().toLowerCase()));
      if (!card.hidden) count++;
    });
    document.getElementById('library-category').textContent = label;
    document.getElementById('result-count').textContent = count + (count === 1 ? ' guide' : ' guides') + (input.value.trim() ? ' matching “' + input.value.trim() + '”' : ' in ' + label.toLowerCase());
  };
  buttons.forEach(b => b.addEventListener('click', () => {filter = b.dataset.filter;update();}));
  input.addEventListener('input',update);
  update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["as-bata-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('as-bata-size-guide')) {
    customElements.define('as-bata-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || this.ready) return;
        this.ready = true;
        this.opener = this.querySelector('[data-guide-open]');
        if (typeof this.dialog.showModal !== 'function') return;
        this.opener.setAttribute('role', 'button');
        this.opener.setAttribute('aria-haspopup', 'dialog');
        this.opener.setAttribute('aria-expanded', 'false');
        this.opener.addEventListener('click', event => { event.preventDefault(); this.openGuide(); });
        this.opener.addEventListener('keydown', event => { if (event.key === ' ') { event.preventDefault(); this.openGuide(); } });
        this.querySelector('[data-guide-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => this.afterClose());
        this.dialog.addEventListener('click', event => {
          const box = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) this.dialog.close();
        });
        this.tabs = Array.from(this.querySelectorAll('[data-guide-tab]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(tab));
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.selectTab(this.tabs[next]); this.tabs[next].focus();
          });
        });
        this.querySelectorAll('[data-guide-note]').forEach(link => link.addEventListener('click', event => {
          event.preventDefault(); const note = this.querySelector('.as-bata-guide__fit-note'); note.scrollIntoView({block:'nearest'}); note.focus({preventScroll:true});
        }));
      }
      openGuide() {
        if (this.dialog.open) return;
        const field = this.nextElementSibling;
        const choice = field?.querySelector('input[type="radio"]:checked, select');
        const size = choice?.tagName === 'SELECT' ? choice.selectedOptions[0]?.textContent.trim().split(/\s/)[0] : choice?.value || this.dataset.selectedSize;
        this.querySelectorAll('[data-guide-size]').forEach(row => row.classList.toggle('as-bata-guide__selected', row.dataset.guideSize === size));
        const status = this.querySelector('[data-guide-selection]');
        status.textContent = status.dataset.template.replace('[size]', size);
        this.selectTab(this.tabs[0]);
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        this.opener.setAttribute('aria-expanded', 'true');
        this.querySelector('.as-bata-guide__content').scrollTop = 0;
        this.querySelector('[data-guide-close]').focus({preventScroll:true});
      }
      selectTab(tab) {
        this.tabs.forEach(button => { const active = button === tab; button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1; });
        this.querySelectorAll('[data-guide-panel]').forEach(panel => { panel.hidden = panel.dataset.guidePanel !== tab.dataset.guideTab; });
        this.querySelector('.as-bata-guide__content').scrollTop = 0;
      }
      afterClose() {
        if (this.previousOverflow !== undefined) { document.body.style.overflow = this.previousOverflow; this.previousOverflow = undefined; }
        this.opener?.setAttribute('aria-expanded', 'false');
        if (this.opener?.isConnected) this.opener.focus({preventScroll:true});
      }
      disconnectedCallback() { if (this.dialog?.open) this.dialog.close(); this.afterClose(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["as-inline-related"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('as-inline-related')) {
    customElements.define('as-inline-related', class extends HTMLElement {
      async connectedCallback() {
        if (this.hidden) return;
        this.controller = new AbortController();
        try {
          const response = await fetch(this.dataset.url, {signal: this.controller.signal});
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const results = html.querySelector('.as-inline-related-results');
          if (!results || !this.isConnected) return;
          this.querySelector('[data-related-results]').replaceChildren(...results.childNodes);
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, ({cartData}) => {
              if (!cartData) return;
              const ids = Array.isArray(cartData.items) && typeof cartData.item_count === 'number'
                ? cartData.items.map(item => String(item.product_id))
                : [String(cartData.product_id || '')];
              this.querySelectorAll('[data-related-product]').forEach(row => {
                if (ids.includes(row.dataset.relatedProduct)) row.remove();
              });
              const list = this.querySelector('[data-related-list]');
              if (list && !list.children.length) this.querySelector('[data-related-results]').replaceChildren();
            });
          }
        } catch (error) {
          if (error.name !== 'AbortError') this.dataset.loadFailed = 'true';
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.unsubscribe?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["as-mobile-purchase-flow"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('as-mobile-purchase-flow')) return;
  customElements.define('as-mobile-purchase-flow', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.product = this.closest('product-info');
      if (!this.product) return;
      this.mobile = matchMedia('(max-width: 989px)');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.shipping = this.product.querySelector('as-shipping-estimator');
      this.quantity = this.product.querySelector('.product-form__quantity');
      this.deliveryDetails = this.shipping?.querySelector('details');
      this.deliveryWasOpen = this.deliveryDetails?.open;
      this.viewer = this.product.querySelector('[id^="GalleryViewer"]');
      if (this.shipping) {
        this.shippingHome = document.createElement('span');
        this.shippingHome.hidden = true;
        this.shipping.before(this.shippingHome);
        this.shipping.classList.add('as-mobile-delivery');
      }
      this.sku = this.product.querySelector('.product__sku');
      this.inventory = this.product.querySelector('.product__inventory');
      this.confidence = this.product.querySelector('as-product-confidence');
      this.policy = this.confidence?.querySelector('[data-as-delivery-policy]');
      this.policyContent = this.policy?.querySelector('[data-as-delivery-policy-content]');
      if (this.policyContent) {
        this.policyHome = document.createElement('span');
        this.policyHome.hidden = true;
        this.policyContent.before(this.policyHome);
      }
      this.support = this.product.querySelector('.as-product-buying-support');
      this.payment = this.support?.querySelector('.as-product-payment-panel');
      for (const name of ['sku', 'inventory', 'quantity', 'support', 'payment']) {
        if (!this[name]) continue;
        const marker = document.createElement('span');
        marker.hidden = true;
        this[name].before(marker);
        this[name + 'Home'] = marker;
      }
      this.bar = this.querySelector('.as-mobile-buybar');
      if (!this.bar) return;
      this.product.append(this.bar);
      this.barStatus = this.bar.querySelector('[data-buybar-status]');
      this.barQuantity = this.bar.querySelector('[data-buybar-quantity]');
      this.barSupport = this.bar.querySelector('[data-buybar-support]');
      this.barPayments = this.bar.querySelector('[data-buybar-payments]');
      this.disclosure = this.bar.querySelector('[data-buybar-disclosure]');
      this.barButton = this.bar.querySelector('.as-mobile-buybar__button');
      document.addEventListener('pointerdown', (event) => {
        if (this.disclosure.open && !this.disclosure.contains(event.target) && !document.querySelector('[id^="ai-price-request-modal-"]:not([hidden])')) this.disclosure.open = false;
      }, {signal});
      this.disclosure.addEventListener('keydown', (event) => {
        if (this.disclosure.open && event.key === 'Escape') {
          this.disclosure.open = false;
          this.disclosure.querySelector('summary').focus({preventScroll: true});
          event.preventDefault();
          event.stopPropagation();
        }
      }, {signal});
      this.barResize = new ResizeObserver(() => {
        const height = this.bar.getBoundingClientRect().height;
        if (height > 0) document.body.style.setProperty('--as-mobile-buybar-height', Math.ceil(height) + 'px');
      });
      this.barResize.observe(this.bar);
      this.barButton.addEventListener('click', () => {
        const primary = this.product.querySelector('button[id^="ProductSubmitButton-"]');
        if (primary && !primary.disabled && primary.getAttribute('aria-disabled') !== 'true') {
          this.barButton.focus({preventScroll: true});
          primary.click();
        }
      }, {signal});
      this.syncBar = () => {
        const primary = this.product.querySelector('button[id^="ProductSubmitButton-"]');
        const price = this.product.querySelector('[id^="price-"] .price');
        const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular:not(s)');
        const shortPrice = (node) => (node?.textContent.trim() || '').replace(/\s+AUD$/, '');
        const currentPrice = this.bar.querySelector('[data-buybar-price]');
        currentPrice.textContent = shortPrice(amount);
        const compare = price?.classList.contains('price--on-sale') ? price.querySelector('.price__sale .price-item--regular') : null;
        const comparePrice = this.bar.querySelector('[data-buybar-compare]');
        comparePrice.textContent = shortPrice(compare);
        comparePrice.hidden = !compare || !comparePrice.textContent;
        this.bar.querySelector('[data-buybar-sale]').hidden = comparePrice.hidden;
        if (primary) {
          this.barButton.textContent = primary.querySelector('span')?.textContent.trim() || primary.textContent.trim();
          this.barButton.disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true' || primary.classList.contains('loading');
        }
        const editing = this.mobile.matches && !this.bar.contains(document.activeElement) && !document.querySelector('cart-drawer.active') && document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable="true"]');
        const enabled = !!primary && !!amount;
        this.placeControls(enabled);
        this.bar.hidden = !enabled || !!editing;
        document.body.classList.toggle('as-mobile-buybar-active', enabled);
      };
      this.observer = new MutationObserver((records) => {
        if (records.some((record) => !this.bar.contains(record.target))) this.syncBar();
      });
      this.observer.observe(this.product, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class']});
      document.addEventListener('focusin', this.syncBar, {signal});
      document.addEventListener('as:cart-closed', this.syncBar, {signal});
      document.addEventListener('focusout', () => queueMicrotask(this.syncBar), {signal});
      window.visualViewport?.addEventListener('resize', this.syncBar, {signal});
      this.update = () => {
        this.disclosure.open = false;
        const summary = this.bar.querySelector('.as-mobile-buybar__summary');
        if (this.mobile.matches && this.disclosure.previousElementSibling !== summary) summary.after(this.disclosure);
        else if (!this.mobile.matches && this.bar.lastElementChild !== this.disclosure) this.bar.append(this.disclosure);
        if (this.deliveryDetails && !this.deliveryInitialised) {
          this.deliveryDetails.open = false;
          this.deliveryInitialised = true;
        }
        this.viewer?.resetPages?.();
        const confidence = this.confidence;
        const facts = confidence?.querySelector('.as-pc2__facts');
        confidence?.classList.add('as-pc2--cards');
        if (this.shipping && facts) {
          if (this.shipping.parentElement !== facts) facts.prepend(this.shipping);
          const deliveryBody = this.shipping.querySelector('.as-shipping__body');
          if (this.policyContent && deliveryBody && this.policyContent.parentElement !== deliveryBody) {
            deliveryBody.append(this.policyContent);
          }
          if (this.policy && this.policyContent?.parentElement === deliveryBody) this.policy.hidden = true;
        }
        this.syncBar();
      };
      this.mobile.addEventListener('change', this.update, {signal});
      this.update();
    }
    placeControls(enabled) {
      for (const [name, destination] of [['sku', this.barStatus], ['inventory', this.barStatus], ['quantity', this.barQuantity], ['support', this.barSupport], ['payment', this.mobile.matches ? this.support || this.barSupport : this.barPayments]]) {
        if (!this[name]) continue;
        if (enabled && name === 'sku') {
          if (this.mobile.matches) {
            const title = this.product.querySelector('.product__title');
            if (title && title.nextElementSibling !== this.sku) title.after(this.sku);
          } else if (this.barStatus.firstElementChild !== this.sku) this.barStatus.prepend(this.sku);
          continue;
        }
        if (enabled && this[name].parentElement !== destination) destination.append(this[name]);
        else if (!enabled && this[name + 'Home']?.isConnected && this[name].previousElementSibling !== this[name + 'Home']) this[name + 'Home'].after(this[name]);
      }
    }
    beforeConfidenceRefresh() {
      if (this.shipping && this.shippingHome?.isConnected) this.shippingHome.after(this.shipping);
      this.policyContent?.remove();
      this.policyHome?.remove();
    }
    afterConfidenceRefresh() {
      this.confidence = this.product.querySelector('as-product-confidence');
      this.policy = this.confidence?.querySelector('[data-as-delivery-policy]');
      this.policyContent = this.policy?.querySelector('[data-as-delivery-policy-content]');
      if (this.policyContent) {
        this.policyHome = document.createElement('span');
        this.policyHome.hidden = true;
        this.policyContent.before(this.policyHome);
      }
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.barResize?.disconnect();
      document.body.style.removeProperty('--as-mobile-buybar-height');
      this.placeControls(false);
      this.bar?.remove();
      document.body.classList.remove('as-mobile-buybar-active');
      this.confidence?.classList.remove('as-pc2--cards');
      if (this.policyContent && this.policyHome?.isConnected) this.policyHome.after(this.policyContent);
      this.policyHome?.remove();
      if (this.policy) this.policy.hidden = false;
      this.shipping?.classList.remove('as-mobile-delivery');
      if (this.shipping && this.shippingHome?.isConnected) this.shippingHome.after(this.shipping);
      this.shippingHome?.remove();
      for (const name of ['sku', 'inventory', 'quantity', 'support', 'payment']) {
        if (this[name] && this[name + 'Home']?.isConnected) this[name + 'Home'].after(this[name]);
        this[name + 'Home']?.remove();
      }
      this.controller = null;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["as-product-extras"] && !Shopify.designMode) return;
  try {
    (() => {
  const register = () => {
    if (customElements.get('as-product-extras')) return;
    customElements.define('as-product-extras', class extends HTMLElement {
      connectedCallback() {
        const productInfo = this.closest('product-info');
        const media = productInfo?.querySelector('.product__media-wrapper');
        if (media && !productInfo.querySelector('.product--no-media')) {
          let home = productInfo.querySelector('[data-as-extras-home]');
          if (!home) {
            home = document.createElement('span');
            home.hidden = true;
            home.dataset.asExtrasHome = '';
            this.before(home);
          }
          this.layoutQuery = window.matchMedia('(min-width: 990px)');
          this.onLayoutChange = () => {
            const desktop = this.layoutQuery.matches;
            productInfo.classList.toggle('as-extras-beside-info', desktop);
            if (desktop && this.parentElement !== media) media.append(this);
            else if (!desktop && this.previousElementSibling !== home) home.after(this);
          };
          if ((this.layoutQuery.matches && this.parentElement !== media) || (!this.layoutQuery.matches && this.previousElementSibling !== home)) {
            this.onLayoutChange();
            return;
          }
          productInfo.classList.toggle('as-extras-beside-info', this.layoutQuery.matches);
          this.layoutQuery.addEventListener('change', this.onLayoutChange);
          this.layoutResize = new ResizeObserver(() => {
            this.style.setProperty('--as-extras-height', this.getBoundingClientRect().height + 'px');
          });
          this.layoutResize.observe(this);
        }
        this.cartProducts = new Set((this.dataset.cartProducts || '').split(',').filter(Boolean));
        this.cartVariants = new Set((this.dataset.cartVariants || '').split(',').filter(Boolean));
        this.includedVariants = new Set();
        this.includedCapabilities = new Set();
        this.setupQuantities();
        this.updateButton = (row) => {
          const form = row.querySelector('form');
          if (!form) return;
          const id = form.querySelector('[name="id"]').value;
          const present = row.dataset.component === 'true' ? this.cartVariants.has(id) : this.cartProducts.has(row.dataset.productId);
          const button = form.querySelector('[type="submit"]');
          const included = this.includedVariants.has(id) || (row.dataset.capability && this.includedCapabilities.has(row.dataset.capability));
          button.disabled = !id || present || included || this.busy;
          const checkbox = row.querySelector('[data-bundle-select]');
          if (checkbox) { checkbox.disabled = button.disabled; if (checkbox.disabled) checkbox.checked = false; }
          button.querySelector('span').textContent = included ? this.dataset.includedLabel : present && id ? this.dataset.addedLabel : this.dataset.addLabel;
        };
        this.onChoice = (event) => {
          const context = event.target.closest('[data-fit-context]');
          if (context && this.contains(context)) {
            const row = context.closest('.as-extras__item');
            const select = row.querySelector('[data-extra-select]');
            const ids = new Set((context.selectedOptions[0]?.dataset.variantIds || '').split(','));
            const options = [...row.querySelector('[data-fit-options]').content.querySelectorAll('option')].filter(option => ids.has(option.value));
            select.replaceChildren(select.options[0].cloneNode(true), ...options.map(option => option.cloneNode(true)));
            select.value = '';
            select.disabled = !context.value || !options.length;
            row.querySelector('[data-bundle-select]').checked = false;
            select.dispatchEvent(new Event('change', {bubbles:true}));
            return;
          }
          const select = event.target.closest('[data-extra-select]');
          if (!select || !this.contains(select)) { this.updateBundle(); return; }
          const row = select.closest('.as-extras__item');
          const form = select.closest('form');
          const option = select.selectedOptions[0];
          form.querySelector('[name="id"]').value = select.value;
          this.syncQuantity(form, select.value ? option : null);
          const stock = row.querySelector('[data-extra-stock]');
          stock.textContent = option.dataset.stock || '';
          stock.dataset.stockState = option.dataset.stockState || '';
          const model = row.querySelector('[data-extra-model]');
          const modelValue = select.value ? option.dataset.model || '' : '';
          model.querySelector('[data-extra-model-value]').textContent = modelValue;
          model.hidden = !modelValue;
          const price = row.querySelector('[data-extra-price]');
          price.textContent = option.dataset.price || price.dataset.startingPrice;

          if (select.value) {
            row.dataset.productId = option.dataset.productId;
            row.querySelectorAll('a').forEach(link => { link.href = option.dataset.url; });
            const img = row.querySelector('.as-extras__image img');
            if (img && option.dataset.image) { img.removeAttribute('srcset'); img.src = option.dataset.image; }
          }
          const checkbox = row.querySelector('[data-bundle-select]');
          if (checkbox) { checkbox.dataset.cents = option.dataset.cents || '0'; checkbox.dataset.includes = option.dataset.includes || ''; checkbox.dataset.capabilities = option.dataset.capabilities || ''; }
          this.updateButton(row);
          this.updateBundle();
        };
        this.addEventListener('change', this.onChoice);
        this.refreshCart = async () => {
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(root + 'cart?section_id=as-cart-context', {headers: {'Accept':'text/html'}});
            if (!response.ok || !this.isConnected) return false;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const data = JSON.parse(html.querySelector('[data-as-cart-context]').textContent);
            this.cartProducts = new Set(data.product_ids.map(String));
            this.cartVariants = new Set(data.variant_ids.map(String));
            this.includedVariants = new Set(data.included_variant_ids.flat().filter(Boolean).map(String));
            this.includedCapabilities = new Set(data.included_capabilities.flat().filter(Boolean));
            this.querySelectorAll('.as-extras__item').forEach(this.updateButton);
            this.updateBundle();
            return true;
          } catch { return false; }
        };
        this.updateBundle = () => {
          const boxes = [...this.querySelectorAll('[data-bundle-select]:checked')];
          const included = new Set(boxes.flatMap(box => (box.dataset.includes || '').split(',')).filter(Boolean));
          const capabilities = new Set(boxes.flatMap(box => (box.dataset.capabilities || '').split(',')).filter(Boolean));
          let conflict = false;
          for (const box of boxes) {
            const row = box.closest('.as-extras__item');
            if (included.has(row.querySelector('[name="id"]').value) || capabilities.has(row.dataset.capability)) { box.checked = false; conflict = true; }
          }
          if (conflict) this.querySelector('[data-bundle-status]').textContent = this.dataset.conflictLabel;
          const selected = [...this.querySelectorAll('[data-bundle-select]:checked')];
          const validQuantities = selected.every(box => box.closest('form').querySelector('[name="quantity"]').validity.valid);
          const bundleButton = this.querySelector('[data-bundle-add]');
          if (bundleButton) bundleButton.disabled = this.submitting || !validQuantities;
          const form = document.getElementById('product-form-' + this.dataset.section);
          const quantity = Number(form ? new FormData(form).get('quantity') || 1 : 1);
          let total = Number(this.dataset.sourceCents) * quantity;
          selected.forEach(box => { total += Number(box.dataset.cents) * Number(box.closest('form').querySelector('[name="quantity"]').value || 1); });
          const controls = this.querySelector('[data-bundle-controls]');
          if (controls) controls.hidden = !selected.length;
          const output = this.querySelector('[data-bundle-total]');
          if (output) output.textContent = !validQuantities ? '—' : new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.dataset.currency || 'AUD'}).format(total / 100);
        };
        this.onQuantity = () => this.updateBundle();
        document.addEventListener('change', this.onQuantity);
        this.addSelection = async () => {
          if (this.submitting) return;
          const button = this.querySelector('[data-bundle-add]');
          const status = this.querySelector('[data-bundle-status]');
          const form = document.getElementById('product-form-' + this.dataset.section);
          if (!form || !form.reportValidity()) return;
          if ([...this.querySelectorAll('[data-bundle-select]:checked')].some(box => !box.closest('form').reportValidity())) return;
          const data = new FormData(form);
          const id = data.get('id');
          if (String(id) !== this.dataset.sourceVariant) return;
          const mainButton = form.querySelector('[type="submit"]');
          const wasDisabled = mainButton?.disabled;
          const drawer = document.querySelector('cart-drawer');
          drawer?.setActiveElement(document.activeElement);
          this.submitting = true; this.busy = true; button.disabled = true; status.textContent = '';
          if (mainButton) { mainButton.disabled = true; mainButton.setAttribute('aria-busy', 'true'); }
          try {
            this.busy = false;
            if (!await this.refreshCart()) throw new Error(this.dataset.errorLabel);
            if (!this.isConnected || this.hidden || String(new FormData(form).get('id')) !== String(id)) throw new Error(this.dataset.errorLabel);
            const selected = [...this.querySelectorAll('[data-bundle-select]:checked')];
            this.busy = true;
            if (!selected.length) throw new Error(this.dataset.conflictLabel);
            if (selected.some(box => !box.closest('form').reportValidity())) throw new Error(this.dataset.errorLabel);
            const properties = {};
            for (const [key,value] of data.entries()) if (key.startsWith('properties[')) properties[key.slice(11,-1)] = value;
            const source = {id:Number(id),quantity:Number(data.get('quantity') || 1),properties};
            if (data.get('selling_plan')) source.selling_plan = data.get('selling_plan');
            const items = [source, ...selected.map(box => {
              const extra = new FormData(box.closest('form'));
              const props = {};
              for (const [key,value] of extra.entries()) if (key.startsWith('properties[')) props[key.slice(11,-1)] = value;
              props._as_purchase_mode = 'selected_bundle';
              return {id:Number(extra.get('id')),quantity:Number(extra.get('quantity') || 1),properties:props};
            })];
            const root = window.Shopify?.routes?.root || '/';
            const payload = {items};
            const sections = drawer?.getSectionsToRender().map(section => section.id) || [];
            if (sections.length) { payload.sections = sections; payload.sections_url = window.location.pathname; }
            const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorLabel);
            selected.forEach(box => { box.checked = false; });
            if (drawer && sections.every(section => typeof result.sections?.[section] === 'string')) {
              try {
                drawer.classList.remove('is-empty');
                drawer.renderContents({...result, id:source.id});
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                  Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {source:'as-product-extras',productVariantId:source.id,cartData:result})).catch(() => {});
                }
              } catch { window.location.assign(root + 'cart'); }
            } else { window.location.assign(root + 'cart'); }
          } catch (error) {
            status.textContent = error.message || this.dataset.errorLabel;
            form.closest('product-form')?.handleErrorMessage?.(status.textContent);
            this.busy = false;
            await this.refreshCart();
          } finally {
            this.submitting = false; this.busy = false; button.disabled = false;
            if (mainButton) { mainButton.disabled = wasDisabled; mainButton.removeAttribute('aria-busy'); }
            this.updateBundle();
          }
        };
        this.onBundle = event => {
          if (event.target.closest('[data-bundle-add]')) this.addSelection();
        };
        this.onMainSubmit = event => {
          if (event.target.getAttribute('id') !== 'product-form-' + this.dataset.section || this.hidden) return;
          if (!this.submitting && !this.querySelector('[data-bundle-select]:checked')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.addSelection();
        };
        document.addEventListener('submit', this.onMainSubmit, true);
        this.addEventListener('click', this.onBundle);
        this.onPageShow = () => this.refreshCart();
        window.addEventListener('pageshow', this.onPageShow);
        this.refreshCart();
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data.sectionId) !== this.dataset.section) return;
          const next = data.html.getElementById(this.id);
          if (next) this.replaceWith(next.cloneNode(true));
          else this.hidden = true;
        });
        this.unsubscribeOptions = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({data}) => {
          if (this.closest('product-info')?.contains(data.event.target)) this.hidden = true;
        });
        this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
      }
      quantityBounds(input) {
        const min = Math.max(1, Number(input.min) || 1);
        const step = Math.max(1, Number(input.step) || 1);
        const limit = input.max === '' ? Infinity : Number(input.max);
        const max = Number.isFinite(limit) ? min + Math.floor((limit - min) / step) * step : Infinity;
        return {min, step, max};
      }
      syncQuantity(form, option) {
        const input = form.querySelector('[data-extra-quantity-input]');
        if (!input) return;
        if (option) {
          input.min = option.dataset.quantity || '1';
          input.step = option.dataset.increment || '1';
          if (option.dataset.maximum !== '') input.max = option.dataset.maximum || '';
          else input.removeAttribute('max');
          const {min, step, max} = this.quantityBounds(input);
          const value = Number(input.value);
          input.value = String(Math.max(min, Math.min(max, min + Math.floor((Number.isFinite(value) ? value - min : 0) / step) * step)));
        }
        input.disabled = !form.querySelector('[name="id"]').value;
        this.updateQuantityButtons(form);
      }
      updateQuantityButtons(form) {
        const input = form.querySelector('[data-extra-quantity-input]');
        if (!input) return;
        const {min, max} = this.quantityBounds(input);
        const value = Number(input.value);
        form.querySelector('[data-extra-minus]').disabled = input.disabled || value <= min;
        form.querySelector('[data-extra-plus]').disabled = input.disabled || value >= max;
      }
      setupQuantities() {
        this.querySelectorAll('.as-extras__form form').forEach(form => this.syncQuantity(form));
        this.onExtraQuantityInput = event => {
          if (!event.target.matches('[data-extra-quantity-input]')) return;
          this.updateQuantityButtons(event.target.form);
          this.updateBundle();
        };
        this.onExtraQuantityClick = event => {
          const button = event.target.closest('[data-extra-minus], [data-extra-plus]');
          if (!button || !this.contains(button) || this.submitting) return;
          const input = button.form.querySelector('[data-extra-quantity-input]');
          if (input.disabled) return;
          const {min, step, max} = this.quantityBounds(input);
          const value = Number(input.value);
          const direction = button.hasAttribute('data-extra-plus') ? 1 : -1;
          const next = input.validity.valid && Number.isSafeInteger(value) ? value + direction * step : min;
          input.value = String(Math.max(min, Math.min(max, next)));
          input.dispatchEvent(new Event('input', {bubbles:true}));
          input.dispatchEvent(new Event('change', {bubbles:true}));
        };
        this.onExtraSubmit = event => {
          const form = event.target;
          if (!form.matches('.as-extras__form form')) return;
          const button = form.querySelector('[type="submit"]');
          if (this.submitting || button.disabled || !form.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };
        this.addEventListener('input', this.onExtraQuantityInput);
        this.addEventListener('click', this.onExtraQuantityClick);
        this.addEventListener('submit', this.onExtraSubmit, true);
      }
      disconnectedCallback() {
        this.removeEventListener('input', this.onExtraQuantityInput);
        this.removeEventListener('click', this.onExtraQuantityClick);
        this.removeEventListener('submit', this.onExtraSubmit, true);
        this.layoutQuery?.removeEventListener('change', this.onLayoutChange);
        this.layoutResize?.disconnect();
        this.removeEventListener('change', this.onChoice);
        this.removeEventListener('click', this.onBundle);
        document.removeEventListener('submit', this.onMainSubmit, true);
        document.removeEventListener('change', this.onQuantity);
        window.removeEventListener('pageshow', this.onPageShow);
        this.unsubscribeVariant?.(); this.unsubscribeOptions?.(); this.unsubscribeCart?.();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', register, {once:true});
  else register();
})();
(() => {
  if (customElements.get('as-extra-dropdown')) return;
  let sequence = 0;
  customElements.define('as-extra-dropdown', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const select = this.querySelector('select');
      if (!select) return;
      this.controller = new AbortController();
      const listen = (node, type, fn, options = {}) => node.addEventListener(type, fn, {...options, signal:this.controller.signal});
      const trigger = document.createElement('button');
      trigger.type = 'button'; trigger.className = 'as-choice__trigger';
      trigger.setAttribute('role','combobox'); trigger.setAttribute('aria-haspopup','listbox');
      trigger.setAttribute('aria-expanded','false');
      const text = document.createElement('span'); trigger.append(text);
      const popup = document.createElement('div');
      popup.id = 'as-choice-list-' + (++sequence); popup.className = 'as-choice__list';
      popup.setAttribute('role','listbox'); popup.hidden = true;
      trigger.setAttribute('aria-controls',popup.id);
      const name = select.getAttribute('aria-label') || Array.from(select.labels || []).map(label=>label.textContent.trim()).join(' ') || select.options[0]?.textContent || 'Choose an option';
      trigger.setAttribute('aria-label',name); popup.setAttribute('aria-label',name);
      if (select.hasAttribute('aria-describedby')) trigger.setAttribute('aria-describedby',select.getAttribute('aria-describedby'));
      this.oldTabIndex = select.getAttribute('tabindex'); this.oldAriaHidden = select.getAttribute('aria-hidden');
      select.tabIndex = -1; select.setAttribute('aria-hidden','true');
      this.append(trigger); document.body.append(popup); this.trigger = trigger; this.popup = popup; this.select = select;
      let active = -1, typeBuffer = '', typedAt = 0;
      const close = () => { popup.hidden = true; trigger.setAttribute('aria-expanded','false'); trigger.removeAttribute('aria-activedescendant'); };
      const position = () => {
        if (popup.hidden) return;
        const r = trigger.getBoundingClientRect(), margin = 8;
        const below = window.innerHeight - r.bottom - margin, above = r.top - margin;
        const up = below < 180 && above > below;
        popup.style.width = Math.min(r.width, window.innerWidth - margin * 2) + 'px';
        popup.style.left = Math.max(margin,Math.min(r.left,window.innerWidth-r.width-margin)) + 'px';
        popup.style.maxHeight = Math.max(44,Math.min(300,up?above-4:below-4)) + 'px';
        popup.style.top = (up ? r.top - popup.offsetHeight - 4 : r.bottom + 4) + 'px';
      };
      const enabled = () => Array.from(popup.children).filter(node=>node.getAttribute('aria-disabled')!=='true');
      const highlight = index => {
        active = index;
        Array.from(popup.children).forEach(node=>node.classList.toggle('is-active',Number(node.dataset.index)===index));
        const node = Array.from(popup.children).find(node=>Number(node.dataset.index)===index);
        if (node) { trigger.setAttribute('aria-activedescendant',node.id); node.scrollIntoView({block:'nearest'}); }
      };
      const sync = () => {
        text.textContent = select.selectedOptions[0]?.textContent || select.options[0]?.textContent || name;
        trigger.disabled = select.disabled; trigger.setAttribute('aria-required',String(select.required));
        popup.replaceChildren();
        Array.from(select.options).forEach((option,index)=>{
          if (option.hidden) return;
          const node = document.createElement('div'); node.className='as-choice__option';
          node.id=popup.id+'-'+index; node.dataset.index=String(index); node.textContent=option.textContent;
          node.setAttribute('role','option'); node.setAttribute('aria-selected',String(index===select.selectedIndex));
          node.setAttribute('aria-disabled',String(option.disabled || !!option.closest('optgroup:disabled'))); popup.append(node);
        });
        if (select.disabled) close();
        else if (!popup.hidden) { position(); highlight(select.selectedIndex); }
      };
      const open = () => {
        if (trigger.disabled) return;
        document.dispatchEvent(new CustomEvent('as-choice-open',{detail:this}));
        sync(); popup.hidden=false; trigger.setAttribute('aria-expanded','true'); position();
        const options=enabled(); highlight(options.some(n=>Number(n.dataset.index)===select.selectedIndex)?select.selectedIndex:Number(options[0]?.dataset.index ?? -1));
      };
      const choose = index => {
        const option = select.options[index];
        if (!option || option.disabled || option.hidden || option.closest('optgroup:disabled')) return;
        select.selectedIndex=index; close(); select.dispatchEvent(new Event('input',{bubbles:true})); select.dispatchEvent(new Event('change',{bubbles:true})); sync(); trigger.focus({preventScroll:true});
      };
      listen(trigger,'click',()=>popup.hidden?open():close());
      listen(popup,'pointerdown',event=>event.preventDefault());
      listen(popup,'click',event=>{const node=event.target.closest('[role="option"]');if(node)choose(Number(node.dataset.index));});
      listen(trigger,'keydown',event=>{
        const key=event.key;
        if (key==='Escape') { if (!popup.hidden) {event.preventDefault();event.stopPropagation();close();} return; }
        if (key==='Tab') {close();return;}
        if (key==='Enter'||key===' ') {event.preventDefault();if(popup.hidden)open();else choose(active);return;}
        if (['ArrowDown','ArrowUp','Home','End'].includes(key)) {
          event.preventDefault();if(popup.hidden){open();return;}
          const options=enabled(), current=options.findIndex(n=>Number(n.dataset.index)===active);
          const index=key==='Home'?0:key==='End'?options.length-1:Math.max(0,Math.min(options.length-1,current+(key==='ArrowDown'?1:-1)));
          if(options[index])highlight(Number(options[index].dataset.index));return;
        }
        if(key.length===1&&!event.ctrlKey&&!event.metaKey&&!event.altKey){
          event.preventDefault();if(popup.hidden)open();const now=Date.now();typeBuffer=now-typedAt>700?key:typeBuffer+key;typedAt=now;
          const node=enabled().find(n=>n.textContent.trim().toLowerCase().startsWith(typeBuffer.toLowerCase()));if(node)highlight(Number(node.dataset.index));
        }
      });
      listen(document,'pointerdown',event=>{if(!this.contains(event.target)&&!popup.contains(event.target))close();});
      listen(document,'focusin',event=>{if(!this.contains(event.target)&&!popup.contains(event.target))close();});
      listen(document,'as-choice-open',event=>{if(event.detail!==this)close();});
      listen(window,'resize',position); listen(window,'scroll',position,{capture:true,passive:true});
      listen(select,'change',()=>queueMicrotask(sync)); listen(select,'focus',()=>trigger.focus());
      listen(select,'invalid',event=>{event.preventDefault();trigger.focus();trigger.setAttribute('aria-invalid','true');open();});
      listen(select,'change',()=>trigger.removeAttribute('aria-invalid'));
      if(select.form)listen(select.form,'reset',()=>setTimeout(sync,0));
      this.observer=new MutationObserver(sync); this.observer.observe(select,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','selected','hidden','label','value']});
      sync();
    }
    disconnectedCallback() {
      this.controller?.abort();this.controller=null;this.observer?.disconnect();this.popup?.remove();this.trigger?.remove();
      if(this.select){if(this.oldTabIndex===null)this.select.removeAttribute('tabindex');else this.select.setAttribute('tabindex',this.oldTabIndex);if(this.oldAriaHidden===null)this.select.removeAttribute('aria-hidden');else this.select.setAttribute('aria-hidden',this.oldAriaHidden);}
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["as-review-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('as-review-summary')) {
  customElements.define('as-review-summary', class extends HTMLElement {
    connectedCallback() {
      this.enhanceRatings = () => {
        document.querySelectorAll('.as-pd-reviews .prorw_range_container:not(.as-rating-enhanced)').forEach(container => {
          const range = container.querySelector('input[type=range]');
          const field = container.querySelector('input.prorw_review_customize_field');
          const title = container.parentElement.querySelector('.prorw-field-label')?.textContent.trim();
          if (!range || !field || !['Quality','Value for money'].includes(title) || range.min !== '1' || range.max !== '5') return;
          const group = document.createElement('div');
          group.className = 'as-feedback-stars';
          group.setAttribute('role','radiogroup');
          group.setAttribute('aria-label',title);
          const caption = document.createElement('p');
          caption.className = 'as-feedback-caption';
          const words = ['Poor','Fair','Good','Very good','Excellent'];
          const buttons = [];
          const selected = () => field.value === '' ? 0 : Number(field.value) + 1;
          const paint = (value) => {
            buttons.forEach((button,index) => {
              button.dataset.lit = String(index < value);
              button.setAttribute('aria-checked',String(index + 1 === selected()));
            });
            const text = value ? value + ' / 5 — ' + words[value - 1] : 'Optional — choose a rating';
            if (caption.textContent !== text) caption.textContent = text;
          };
          const choose = value => {
            range.value = String(value);
            range.dispatchEvent(new Event('input',{bubbles:true}));
            range.dispatchEvent(new Event('change',{bubbles:true}));
            paint(selected());
          };
          for(let value=1;value<=5;value++){
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('role','radio');
            button.setAttribute('aria-label',value + ' out of 5 — ' + words[value-1]);
            button.textContent = '★';
            button.addEventListener('click',() => choose(value));
            button.addEventListener('pointerenter',event => {if(event.pointerType !== 'touch') paint(value);});
            button.addEventListener('keydown',event => {
              let next = value;
              if(['ArrowRight','ArrowUp'].includes(event.key)) next = Math.min(5,value+1);
              else if(['ArrowLeft','ArrowDown'].includes(event.key)) next = Math.max(1,value-1);
              else if(event.key === 'Home') next = 1;
              else if(event.key === 'End') next = 5;
              else return;
              event.preventDefault();
              choose(next);
              buttons[next-1].focus();
            });
            buttons.push(button);
            group.append(button);
          }
          group.addEventListener('pointerleave',() => paint(selected()));
          range.addEventListener('change',() => paint(selected()));
          container.classList.add('as-rating-enhanced');
          container.append(group,caption);
          paint(selected());
        });
      };
      this.sync = () => {
        this.enhanceRatings();
        const widget = document.getElementById('prorw_reviews_container_data');
        const info = widget?.querySelector('#prorw_current_product_info_review');
        const main = this.closest('product-info');
        if (!info || (main?.dataset.productId && main.dataset.productId !== info.dataset.prorwProductId)) return;
        const count = Number(info.dataset.mainCount?.trim());
        const average = Number(info.dataset.averageRatings);
        if (!Number.isFinite(count) || count < 0 || !Number.isFinite(average) || average < 0 || average > 5) return;
        const fullLabel = count > 0 ? average.toFixed(1) + ' ' + this.dataset.ratingLabel + ', ' + count + ' ' + this.dataset.countLabel : this.dataset.empty;
        const text = this.dataset.compact === 'true' && count > 0 ? average.toFixed(1) + ' (' + count + ')' : count > 0 ? average.toFixed(1) + ' / 5 · ' + count + ' ' + this.dataset.countLabel : this.dataset.empty;
        this.querySelector('.as-review-summary__read').setAttribute('aria-label', fullLabel);
        const output = this.querySelector('[data-review-summary-text]');
        if (output.textContent !== text) output.textContent = text;
        this.querySelector('.as-review-summary__stars').style.setProperty('--as-rating-fill', (count > 0 ? average * 20 : 0) + '%');
        this.hidden = false;
      };
      this.clickHandler = event => {
        const write = event.target.closest('.as-review-summary__write');
        const read = event.target.closest('.as-review-summary__read');
        if (!write && !read) return;
        const widget = document.getElementById('prorw_reviews_container_data');
        if (!widget) return;
        event.preventDefault();
        if (write) {
          const action = widget.querySelector('#prorw_review_summary_action_write_review');
          if (action?.getAttribute('aria-expanded') !== 'true') action?.click();
          requestAnimationFrame(() => {
            const form = widget.querySelector('.prorw-review-form-tab');
            form?.scrollIntoView({block:'start',behavior:'auto'});
            widget.querySelector('#prorw_review_form_title')?.focus({preventScroll:true});
          });
        } else {
          widget.scrollIntoView({block:'start',behavior:'auto'});
          widget.querySelector('#prorw_reviews_widget_title')?.focus({preventScroll:true});
        }
      };
      this.addEventListener('click',this.clickHandler);
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.sync);
      });
      this.observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['data-average-ratings','data-main-count']});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.removeEventListener('click',this.clickHandler);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
